import { Alert, Box, SxProps, Theme, Typography } from '@mui/material';

// Direct path, not the application barrel: this file is inside it, and importing it from itself
// is a cycle (see CasPendingEmailsPill in CasContextProviders).
import { SmsTextAdjustmentType } from '../smsSpamSafeText';

export interface BatchSmsAdjustedType {
  // The message the wording was changed in, named as the list names it.
  label: string;
  adjustments: SmsTextAdjustmentType[];
}

interface Props {
  changed: BatchSmsAdjustedType[];
  onClose: VoidFunction;
  sx?: SxProps<Theme>;
}

/*
  What Send just reworded in a batch's texts for the carriers, and why it stopped: the sender looks
  the messages over - each one opens from the list as usual - and presses Send again.

  Grouped by message: in a batch most of these bodies are off screen, so saying only WHAT changed
  would leave them hunting for WHERE.
*/
export default function BatchSmsAdjustmentsAlert({ changed, onClose, sx }: Props) {
  if (!changed.length) return null;

  return (
    <Alert severity="info" onClose={onClose} sx={sx}>
      Some wording was adjusted so carriers are less likely to treat these texts as spam. Review the
      messages and press Send again.
      {/* Capped, so a batch with many reworded rows does not push the messages off the window. */}
      <Box sx={{ mt: 0.5, maxHeight: 160, overflowY: 'auto' }}>
        {changed.map(({ label, adjustments }) => (
          <Box key={label}>
            <Typography variant="caption" sx={{ fontWeight: 600 }}>
              {label}
            </Typography>
            <Box component="ul" sx={{ m: 0, mb: 0.5, pl: 2.5 }}>
              {adjustments.map((adjustment) => (
                <li key={`${adjustment.from}->${adjustment.to}`}>
                  &quot;{adjustment.from}&quot; &rarr; &quot;{adjustment.to}&quot;
                </li>
              ))}
            </Box>
          </Box>
        ))}
      </Box>
    </Alert>
  );
}
